import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: "auto",
  },
  tableWrapper: {
    paddingBlock: 7,
  },
  tiplistoperators: {},
  Endbtn: {
    padding: "5px 0px !important",
    borderRadius: "5px !important",
    display: "flex",
    alignItems: "center",
  },
  buttonStyle: {
    borderRadius: "5px !important",
    whiteSpace: "nowrap",
    fontSize: "clamp(11px, 0.85vw, 13px) !important",
    padding: "5px 14px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "11px !important",
      padding: "5px 10px !important",
    },
  },
  filterstypo: {
    padding: "0 10px",
    position: "absolute !important",
    top: "-10px",
    left: "31px",
  },
  filters: {
    padding: "4px 5px",
    [theme.breakpoints.down("lg")]: {
      padding: "3px 3px",
    },
    [theme.breakpoints.down("md")]: {
      padding: "4px 2px",
    },
    [theme.breakpoints.up("xl")]: {
      padding: "8px 6px",
    },
    "& .MuiInputBase-root": {
      fontSize: "clamp(12px, 0.85vw, 14px)",
    },
    "& .MuiInputLabel-root": {
      fontSize: "clamp(12px, 0.85vw, 14px)",
    },
  },
  txtwidth: {},
  TextFieldwidth: {
    width: "30% !important",
    [theme.breakpoints.down("lg")]: {
      width: "40% !important",
    },
    [theme.breakpoints.down("md")]: {
      width: "100% !important",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
    },
    [theme.breakpoints.up("xl")]: {
      width: "35% !important",
    },
  },
  iconfromdate: {},
  icontodate: {},
  utilities: {
    textAlign: "center",
    padding: "16px 24px",
    [theme.breakpoints.down("lg")]: {
      padding: "10px 12px",
    },
    [theme.breakpoints.down("md")]: {
      padding: "8px 10px",
    },
    [theme.breakpoints.up("xl")]: {
      padding: "20px 40px",
    },
  },
  datePickerStyle: {
    "& .MuiTextField-root": {
      width: "100%",
    },
    "& .MuiFormLabel-root": {
      top: "-5px",
      fontSize: "clamp(12px, 0.85vw, 14px)",
    },
    "& .MuiInputBase-input": {
      height: "0.4375em !important",
      fontSize: "clamp(12px, 0.85vw, 14px)",
    },
  },
  layout: {
    background: "#EAEDEF",
    height: "calc(100vh - 70px)",
    overflowY: "auto",
  },
  title: {
    display: "flex",
    gap: 12,
    justifyContent: "center",
    padding: "20px 0px",
  },
  pages: {
    background: "#fff",
    borderRadius: 8,
    marginTop: 50,
  },
  editIcon: {
    border: `1px solid #11823b`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#11823b",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
  },
  deleteIcon: {
    border: `1px solid #ff2020db`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#ff2020db",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
  },
  historyIcon: {
    border: `1px solid #f140a9`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#000000",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
  },
  actiontypo: {
    padding: 2,
    color: "#fff",
    "&.MuiTypography-subtitle2": {
      fontSize: 14,
    },
  },
  tableHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    rowGap: 8,
    "& .MuiTypography-root": {
      fontWeight: 500,
    },
    "& .MuiButton-root": {
      color: "gray",
      textTransform: "capitalize",
      border: "1px solid #c5baba",
      "&:hover": {
        border: "1px solid #848181",
        backgroundColor: "#fff",
      },
    },
  },

  dataGridTable: {
    padding: "0px 0px",
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: theme.palette.background.paper,
      zIndex: theme.zIndex.mobileStepper - 1,
    },
    "& .MuiDataGrid-virtualScroller": {
      marginTop: "0 !important",
    },
    "& .MuiDataGrid-main": {
      overflow: "visible",
    },
    "& .MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      textTransform: "uppercase",
      fontSize: 14,
    },
    "& .MuiDataGrid-iconSeparator ": {
      display: "none",
    },
    "& .MuiDataGrid-footerContainer": {
      justifyContent: "flex-start",
    },
    "& .MuiTablePagination-selectLabel": {
      fontSize: 13,
    },
    "& .MuiTablePagination-displayedRows": {
      fontSize: 13,
    },
    "& .MuiTablePagination-select": {
      fontSize: 13,
    },
    "& .MuiDataGrid-cell": {
      whiteSpace: "normal !important",
      wordWrap: "break-word",
    },
  },

  // Responsive table container
  tableContainer: {
    width: "100%",
    overflowX: "auto",
    marginBottom: "8px",
    // Thin scrollbar for horizontal scroll
    scrollbarWidth: "thin",
    "&::-webkit-scrollbar": {
      height: 6,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#c1c1c1",
      borderRadius: 3,
    },
    // Below lg breakpoint, enforce min-width so table scrolls horizontally
    [theme.breakpoints.down("lg")]: {
      "& > div": {
        minWidth: 1200,
      },
    },
  },

  // Search bar wrapper
  searchBarWrapper: {
    padding: "12px 16px 4px",
    [theme.breakpoints.down("lg")]: {
      padding: "8px 12px 4px",
    },
  },

  lightText: {
    "& .MuiTypography-root": {
      color: "rgba(0, 0, 0, 0.7)",
    },
  },
  linkText: {
    "& .MuiTypography-root": {
      color: "#0f5fff",
      cursor: "pointer",
    },
  },
  spacing: {
    paddingBlockStart: 4,
  },
  iconsWrapper: {
    display: "flex",
    gap: 8,
  },
}));


export default useStyles;
